import RecruitersHelpers from './models/RecruitersHelpers';

export default { recruiters: RecruitersHelpers };
